'use client';

import { useEffect } from 'react';

import { RadioTile, RadioTiles, Spacer, SpacerSize, Title, TitleLevels, TitleMarkup } from '@bytel/trilogy-react';

import { Connectivity, PlanType } from '@app-types/product';

import { getRadioLabels } from '@helpers/network-radio';

import { useHome } from '@landing/hooks';

interface NetworkButtonsProps {
    baseProduct: PlanType | null;
}

export function NetworkButtons({ baseProduct }: Readonly<NetworkButtonsProps>) {
    const { setSelectedOption, setSelectedNetwork, selectedNetwork } = useHome();

    const isOffer5g = selectedNetwork === Connectivity.FIVE_G || baseProduct?.maxConnections === Connectivity.FIVE_G;
    const isOffer4g = !isOffer5g;

    useEffect(() => {
        setSelectedOption(null);
    }, []);

    if (!baseProduct) {
        return null;
    }

    const onClick = (network: Connectivity) => {
        if (!baseProduct) return;

        setSelectedNetwork(network);
        if (network === Connectivity.FIVE_G && baseProduct.option5g && Object.values(baseProduct.option5g).length > 0) {
            setSelectedOption(baseProduct.option5g);
        } else {
            setSelectedOption(null);
        }
    };

    const { fourGRadio, fiveGRadio } = getRadioLabels(baseProduct, selectedNetwork);

    if (!fourGRadio.valid || !fiveGRadio.valid) {
        return null;
    }

    return (
        <>
            <Spacer size={SpacerSize.FIVE} />
            <Title level={TitleLevels.FIVE} markup={TitleMarkup.H2}>
                Quelle vitesse de connexion&nbsp;?
            </Title>
            <RadioTiles className='grid-radio-list'>
                <RadioTile
                    onChange={() => onClick(Connectivity.FOUR_G)}
                    description={fourGRadio.description}
                    label='4G'
                    horizontal
                    name='checkboxNetwork'
                    value='1'
                    checked={isOffer4g}
                    id='4G'
                />
                <RadioTile
                    onChange={() => onClick(Connectivity.FIVE_G)}
                    description={fiveGRadio.description}
                    checked={isOffer5g}
                    label='5G'
                    horizontal
                    id='5G'
                />
            </RadioTiles>
        </>
    );
}
